import {Icon} from "./icon.component";

export * from './icon.component';
export default Icon;

customElements.define('wl-icon', Icon);